// quote-card Remotion composition：金句卡片，打字机式逐字揭示。
// 专业设计：大引号装饰、径向渐变背景层次、作者强调色、块状光标。
import { AbsoluteFill, useCurrentFrame, useVideoConfig } from 'remotion'
import { quoteRevealed } from './tick'
import type { QuoteData, QuoteBg } from './types'
import type { CompositionProps } from '../../remotion/ScenePlayer'
import { THEME } from '../../remotion/theme'

const BG: Record<QuoteBg, string> = {
  dark: 'linear-gradient(160deg,#0f172a,#1e293b)',
  warm: 'linear-gradient(160deg,#2e1a0f,#3d2010)',
  cool: 'linear-gradient(160deg,#0f172a,#1e3a5f)',
  minimal: 'linear-gradient(160deg,#f8fafc,#e2e8f0)',
}
const ACCENT: Record<QuoteBg, string> = {
  dark: '#6366f1', warm: '#f59e0b', cool: '#3b82f6', minimal: '#6366f1',
}

export const QuoteCardComposition: React.FC<CompositionProps> = ({ data, duration }) => {
  const frame = useCurrentFrame()
  const { fps } = useVideoConfig()
  const d = data as unknown as QuoteData
  const time = frame / fps
  const revealed = quoteRevealed(data, time, duration)
  const bgType = d.background ?? 'dark'
  const isLight = bgType === 'minimal'
  const accent = ACCENT[bgType]
  const mainColor = isLight ? '#0f172a' : THEME.w

  const shown = (d.quote ?? '').slice(0, revealed)
  const done = revealed >= (d.quote?.length ?? 0)

  return (
    <AbsoluteFill style={{
      background: (data as any).bgColor
        ? `radial-gradient(circle at 30% 20%, ${accent}15, transparent 60%), ${(data as any).bgColor}`
        : `radial-gradient(circle at 30% 20%, ${accent}18, transparent 60%), ${BG[bgType]}`,
      fontFamily: THEME.fontSans, padding: 96,
      display: 'flex', flexDirection: 'column', justifyContent: 'center',
    }}>
      {/* 大引号装饰 */}
      <div style={{
        color: accent, fontSize: 200, lineHeight: 0.7, marginBottom: -20,
        opacity: 0.4, fontFamily: 'Georgia, serif', fontWeight: 700,
      }}>
        "
      </div>
      {/* 正文 */}
      <div style={{ color: mainColor, fontSize: 88, fontWeight: 700, lineHeight: 1.35, minHeight: 280 }}>
        {shown}
        {!done && <span style={{ color: accent, opacity: 0.8 }}>▌</span>}
      </div>
      {/* 结束引号 */}
      {done && (
        <div style={{
          color: accent, fontSize: 200, lineHeight: 0.5, marginTop: -30, opacity: 0.4,
          fontFamily: 'Georgia, serif', fontWeight: 700, textAlign: 'right',
        }}>
          "
        </div>
      )}
      {/* 作者：白色名字 + 强调色破折号 */}
      {d.author && (
        <div style={{
          marginTop: 64, fontSize: 52, fontWeight: 800,
          opacity: done ? 1 : 0.4,
          color: mainColor,
        }}>
          <span style={{ color: accent }}>—</span> {d.author}
        </div>
      )}
    </AbsoluteFill>
  )
}
